module.exports = __webpack_public_path__ + "media/honey-icons/icon-notifications-off-93cee942.svg";